// GENERATED FILE - DO NOT MODIFY
export enum PhysicalInventoryStatus {
    Entered = "0",
    Confirmed = "2",
}

export let nameof = "PhysicalInventoryStatus";
